import React ,{useRef,useState,useEffect}from 'react'
import {TextField,Chip} from '@material-ui/core'
import ChipInput from 'material-ui-chip-input'
import { makeStyles } from '@material-ui/core/styles'
import FileGambar from '../../home/FileGambar'
import FileLink from '../../home/FileLink'
import FilePdf from '../../home/FilePdf'
import FileVideo from '../../home/FileVideo'
import Close from 'assets/icon/close.png'
import { useDispatch,useSelector } from 'react-redux'
import { postDiskusi } from 'redux/actions/forum'
import { CircularProgress } from '@material-ui/core'
import { modalToggleReset } from 'redux/actions/general'
const useStyles = makeStyles(theme => ({
    textField: {
      [`& fieldset`]: {
        borderRadius: 10,
        fontWeight:'normal'
      },
      width:'100%',
      marginBottom:15
  },
  
}));

export default function Add_diskusi(props) {
    const inputFile = useRef(null) 
    const dispatch = useDispatch()
    const persist = useSelector(state => state.persist)
    const reducer = useSelector(state => state.reducer)
    const general = useSelector(state => state.general)
    const classes=useStyles()
    const {post_diskusi}=reducer
    const [state, setstate] = useState({
        Id:0,
        ForumId:0,
        ParentId:0,
        Title:'',
        Text:'',
        Tags:[],
        Files:null,
        File_url:'',
        extension:''
    })
    useEffect(() => {
        setstate({...state,ParentId:props.modal_data.ParentId})
    }, [])
    
    
    const onChangeDesc=(e)=>{
        let {value}=e.target
        setstate({...state,Text:value})
    }
    
    
    const onCreate=async ()=>{
        let fd= new FormData()
        fd.append('Id',state.Id)
        fd.append('ForumId',persist.forum_id)
        fd.append('ParentId',state.ParentId)
        fd.append('Title',state.Title)
        fd.append('Text',state.Text)
        fd.append('Files',state.Files)
        let res=await dispatch(postDiskusi(fd))
        if(res){
            dispatch(modalToggleReset())
            props.modal_data.getAction()
            
        }
    }
    return (
        <div>
           {/* <TextField
                label="Judul"
                variant='outlined'
                value={state.Title}
                size='small'
                color='primary'
                name='name'
                // disabled={handleDisable()}
                className={classes.textField}
                onChange={(e)=>setstate({...state,Title:e.target.value})}
                multiline
            /> */}
            <textarea onChange={(e)=>onChangeDesc(e)} value={state.Text}  autoFocus rows="7" className='font-nunito diskusi-field' placeholder="Add desc"></textarea>
            <br/><br/>
            
            <div className=' diskusi-footer'>
                
                <div className='div-flex div-justify-between' style={{width:'100%'}}>
                <div className='file-diskusi div-flex'>
                    
                </div>
                &nbsp;
                <button onClick={onCreate} className='btn-forum'>
                    
                    {general.isLoading?
                    <CircularProgress style={{color:'white'}}  size={20} />
                    :
                    'Balas Komentar'
                    }

                </button>
                </div>
            </div>
            <br/>
        </div>
    )
}
